<div class="auth-content">
  <!-- Login form -->
  <div class="login">
    <div class="logo">
      <img class="image" [src]="theme?.logo">
      <div class="text">
        <div class="title">{{ theme?.product }}</div>
        <div class="subtitle">Workflow Portal</div>
      </div>
    </div>
    <div class="login-form">
      <input class="input" type="email" [(ngModel)]="email" placeholder="Email address" (focus)="error = undefined">
      <div class="input password-input">
        <input type="{{ showPassword ? 'text' : 'password' }}" [(ngModel)]="password" placeholder="Password" (keydown.enter)="login()" (focus)="error = undefined">
        <mat-icon svgIcon="eye" class="toggle" [class.active]="showPassword" (click)="showPassword = !showPassword"></mat-icon>
      </div>
      <div class="forgot-password">Forgot password?</div>
    </div>
    <div class="button login-button" [class.disabled]="!email?.length || !password?.length" (click)="login()">Log in</div>
    @if (error) {
      <div class="message error">{{ error }}</div>
    }
  </div>
  <!-- Logo -->
  <!-- <div class="max-logo">
    <mat-icon svgIcon="max-logo" class="icon"></mat-icon>
  </div> -->
</div>